import { organizationSettingsConstants as osc } from 'srcReact/OrganizationSettingsPage'
import { getOrganizationAccronym } from 'srcReact/helpers/utils'
import { getCurrentOrg } from 'srcReact/helpers/organizationHelper'

const initialState = {
  refresh: false,
  loading: false,
  loaded: false,
  organizationInfo: {
    loading: false,
    loaded: false,
    success: false,
    info: {
      id: '',
      name: '',
      roles: '',
      editable: false,
      billable: false,
      picture: ''
    },
    organizations_basicsettings: {
      color: '',
      accronym: ''
    }
  },
  workplaces: [],
  leadership_team: [],
  member: {
    loading: false,
    loaded: false,
    error: '',
    stats: {
      total_members: 0,
      next_offset: 0,
      remaining_members: 0
    },
    members: []
  },
  plan: {
    id: '',
    name: '',
    billing_period_unit: '',
    billing_period_unit_display: '',
    plan_unit_price: 0,
    currency_code: 'USD',
    organization_member_quantity: 0,
    organization_workplace_quantity: 0,
    workplace_limit: 0,
    available_licenses_count: '',
    current_term_end: ''
  },
  hosted_page: {
    url: ''
  },
  invoices: [],
  error: '',
  deleteAccData: {
    loading: false,
    error: '',
    data: null
  },
  orgFiles: {
    list: [],
    loading: false,
    getFileError: null,
    addUpdateFileError: null,
    deleteFileError: null,
    stats: null,
    success: false
  }
}

export function organizationSettings(state = initialState, action) {
  switch (action.type) {
    case osc.GET_ORGANIZATION_INFO_REQUEST:
      return {
        ...state,
        organizationInfo: {
          ...state.organizationInfo,
          loading: true
        }
      }
    case osc.GET_ORGANIZATION_INFO_SUCCESS:
      return {
        ...state,
        organizationInfo: {
          ...state.organizationInfo,
          ...action.data,
          organizations_basicsettings: {
            ...state.organizationInfo.organizations_basicsettings,
            ...action.data.organizations_basicsettings,
            accronym: action.data.organizations_basicsettings.accronym || getOrganizationAccronym(action.data.info.name)
          },
          loading: false,
          loaded: true
        }
      }
    case osc.GET_ORGANIZATION_INFO_FAILURE: {
      return {
        ...state,
        organizationInfo: {
          ...state.organizationInfo,
          loading: false,
          loaded: false
        }
      }
    }
    case osc.EDIT_ORGANIZATION_INFO_REQUEST:
      return {
        ...state,
        organizationInfo: {
          ...state.organizationInfo,
          loading: true,
          error: null
        }
      }
    //this reducer is also called on organization reducer, to update other states
    case osc.EDIT_ORGANIZATION_INFO_SUCCESS: {
      const { info } = action.data
      if (info?.picture) {
        const updateOrganization = { ...getCurrentOrg(), picture: info.picture }
        localStorage.setItem('current_organization', JSON.stringify(updateOrganization))
      }
      return {
        ...state,
        organizationInfo: {
          ...state.organizationInfo,
          loading: false,
          success: true,
          loaded: true,
          info: action.data.info,
          organizations_basicsettings: action.data.organizations_basicsettings
        }
      }
    }
    case osc.EDIT_ORGANIZATION_INFO_FAILURE: {
      return {
        ...state,
        organizationInfo: {
          ...state.organizationInfo,
          loading: false,
          success: false,
          loaded: true,
          translationKeyError: '',
          error: action.error
        }
      }
    }

    case osc.GET_ORGANIZATION_WORKPLACE_LIST_REQUEST:
      return {
        ...state,
        loading: true
      }
    case osc.GET_ORGANIZATION_WORKPLACE_LIST_SUCCESS:
      return {
        ...state,
        workplaces: [...action.data.workplaces],
        loading: false,
        loaded: true
      }

    case osc.GET_LEADERSHIP_TEAM_REQUEST:
      return {
        ...state,
        loading: true
      }
    case osc.GET_LEADERSHIP_TEAM_SUCCESS:
      return {
        ...state,
        leadership_team: [...Object.keys(action.data.leadership_team).map((l) => action.data.leadership_team[l])].sort(
          (a, b) => a.lastname.localeCompare(b.lastname)
        ),
        loading: false,
        loaded: true
      }

    case osc.GET_ORGANIZATION_MEMBERS_REQUEST:
      return {
        ...state,
        member: {
          ...state.member,
          loading: true
        }
      }
    case osc.GET_ORGANIZATION_MEMBERS_SUCCESS:
      return {
        ...state,
        member: {
          ...state.member,
          ...action.data.organization_members,
          loading: false,
          loaded: true
        }
      }

    case osc.GET_ORGANIZATION_MEMBERS_FAILURE: {
      return {
        ...state,
        member: {
          ...state.member,
          loading: false,
          loaded: true,
          error: action.error
        }
      }
    }
    case osc.GET_ORGANIZATION_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        loading: true
      }
    case osc.GET_ORGANIZATION_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        ...action.data,
        plan: {
          ...action.data.plan,
          plan_unit_price: action.data.chargebee_data.plan_unit_price,
          currency_code: action.data.chargebee_data.currency_code,
          billing_period_unit_display: action.data.chargebee_data.billing_period_unit_display,
          billing_period_unit: action.data.chargebee_data.billing_period_unit,
          organization_workplace_quantity: action.data.organization_workplace_quantity,
          organization_member_quantity: action.data.organization_member_quantity,
          available_licenses_count: action.data.organization_subscription.available_licenses_count,
          current_term_end: action.data.chargebee_data.current_term_end
        },
        loading: false,
        loaded: true
      }

    case osc.GET_PAYMENT_INFORMATION_URL_REQUEST:
      return {
        ...state,
        loading: true
      }
    case osc.GET_PAYMENT_INFORMATION_URL_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
        loaded: true
      }

    case osc.GET_INVOICES_REQUEST:
      return {
        ...state,
        loading: true
      }
    case osc.GET_INVOICES_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
        loaded: true
      }

    case osc.GET_DOWNLOAD_INVOICE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case osc.GET_DOWNLOAD_INVOICES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }

    case osc.DELETE_WORKPLACE_REQUEST:
    case osc.UPDATE_MEMBER_ROLE_REQUEST:
    case osc.REMOVE_MEMBER_REQUEST:
    case osc.REINSTATE_ACCOUNT_REQUEST:
      return {
        ...state
      }
    case osc.DELETE_WORKPLACE_SUCCESS:
    case osc.REINSTATE_ACCOUNT_SUCCESS: {
      return {
        ...state,
        refresh: !state.refresh,
        member: {
          ...state.member,
          error: ''
        }
      }
    }

    case osc.REMOVE_MEMBER_SUCCESS: {
      let updatedMembers = state.member.members
      if (action.data.removed === 1) {
        updatedMembers = state.member.members.filter((user) => user.resourceKey !== action.user_id)
      }
      return {
        ...state,
        member: {
          ...state.member,
          members: updatedMembers
        }
      }
    }
    case osc.UPDATE_MEMBER_ROLE_SUCCESS: {
      const { fromPage, data } = action

      if (fromPage === 'leadership') {
        let updatedLeadership = state.leadership_team.map((member) => {
          if (member.user_id === data.users[0].id) {
            const updatedRole = data?.users[0].roles?.map((role) => role.role).join(',')
            member.role = updatedRole
          }
          return member
        })
        updatedLeadership = updatedLeadership.filter(
          (member) => member.role?.length > 0 && member.role !== 'workplace-member'
        )
        return {
          ...state,
          leadership_team: updatedLeadership
        }
      } else {
        const updatedMembers = state.member.members.map((member) => {
          if (member.resourceKey === data.users[0].id) {
            const updatedRole = data?.users[0].roles?.map((role) => role.role).join(',')
            member.roles = updatedRole
          }
          return member
        })
        return {
          ...state,
          member: {
            ...state.member,
            members: updatedMembers
          }
        }
      }
    }
    case osc.REINSTATE_ACCOUNT_FAILURE:
      return {
        ...state,
        member: {
          ...state.member,
          error: action.error
        }
      }
    case osc.DELETE_ACCOUNT_REQUEST:
      return {
        ...state,
        deleteAccData: {
          ...state.deleteAccData,
          loading: true
        }
      }
    case osc.DELETE_ACCOUNT_SUCCESS: {
      return {
        ...state,
        deleteAccData: {
          ...state.deleteAccData,
          loading: false,
          data: action.response
        },
        ...(action.response.deleted === 1 ? { refresh: !state.refresh } : {})
      }
    }

    case osc.DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        deleteAccData: {
          ...state.deleteAccData,
          loading: false,
          error: action.error
        }
      }
    case osc.GET_ORG_FILES_REQUEST:
      return {
        ...state,
        orgFiles: {
          ...state.orgFiles,
          loadingGetFile: true,
          getFileError: ''
        }
      }
    case osc.GET_ORG_FILES_SUCCESS: {
      return {
        ...state,
        orgFiles: {
          ...state.orgFiles,
          list: action.response.file_list,
          loadingGetFile: false,
          stats: action.response.stats,
          getFileError: ''
        }
      }
    }

    case osc.GET_ORG_FILES_FAILURE:
      return {
        ...state,
        orgFiles: {
          ...state.orgFiles,
          loadingGetFile: false,
          getFileError: action.error
        }
      }

    case osc.ADD_ORG_FILE_REQUEST:
    case osc.UPDATE_ORG_FILE_REQUEST:
      return {
        ...state,
        orgFiles: {
          ...state.orgFiles,
          loadingAddUpdateFile: true,
          addUpdateFileError: ''
        }
      }
    case osc.ADD_ORG_FILE_SUCCESS:
    case osc.UPDATE_ORG_FILE_SUCCESS: {
      return {
        ...state,
        orgFiles: {
          ...state.orgFiles,
          list: action.response.file_list,
          stats: action.response.stats,
          loadingAddUpdateFile: false,
          success: true,
          addUpdateFileError: ''
        }
      }
    }

    case osc.ADD_ORG_FILE_FAILURE:
    case osc.UPDATE_ORG_FILE_FAILURE:
      return {
        ...state,
        orgFiles: {
          ...state.orgFiles,
          loadingAddUpdateFile: false,
          addUpdateFileError: action.error
        }
      }

    case osc.DELETE_ORG_FILE_REQUEST:
      return {
        ...state,
        orgFiles: {
          ...state.orgFiles,
          loading: true,
          deletedId: 0,
          deleteFileError: ''
        }
      }
    case osc.DELETE_ORG_FILE_SUCCESS: {
      const deletedId = action.response.deleted_id
      const updatedList = state.orgFiles.list.filter((x) => x.id != deletedId)
      return {
        ...state,
        orgFiles: {
          ...state.orgFiles,
          list: updatedList,
          loading: false,
          deletedId: deletedId,
          success: true,
          deleteFileError: ''
        }
      }
    }

    case osc.DELETE_ORG_FILE_FAILURE:
      return {
        ...state,
        orgFiles: {
          ...state.orgFiles,
          deleteFileError: action.error
        }
      }
    case osc.UPDATE_ORG_ROLE_REQUEST: {
      return {
        ...state
      }
    }
    case osc.UPDATE_ORG_ROLE_SUCCESS: {
      const { response, userId, listType } = action
      if (listType === 'leadership') {
        let updatedLeadership = state.leadership_team.map((member) => {
          if (member.user_id === userId) {
            const updatedRole = response?.roles?.map((role) => role.role).join(',')
            member.role = updatedRole
          }
          return member
        })
        updatedLeadership = updatedLeadership.filter((member) => member.role?.length > 0)
        return {
          ...state,
          leadership_team: updatedLeadership
        }
      } else {
        const updatedMembers = state.member.members.map((member) => {
          if (member.resourceKey === userId) {
            const updatedRole = response?.roles?.map((role) => role.role).join(',')
            member.organization_role = updatedRole
          }
          return member
        })
        return {
          ...state,
          member: {
            ...state.member,
            members: updatedMembers
          }
        }
      }
    }
    case osc.UPDATE_ORG_ROLE_FAILURE: {
      return {
        ...state,
        member: {
          ...state.member,
          error: action.error
        }
      }
    }

    case osc.CLEAR_FLAGS_ORG_DOCS: {
      return {
        ...state,
        orgFiles: {
          ...state.orgFiles,
          success: false,
          addUpdateFileError: '',
          deleteFileError: ''
        }
      }
    }

    default:
      return state
  }
}
